import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiResponseModel, ApiVisa, BaseApiTemplateService, Core2Config } from '../../shared';
import { Observable } from 'rxjs';
import { MTOItemHdrContainerModel } from '../../../../../../models/aggregates/erp/mto/mto-item-hdr-container.model';





@Injectable({
  providedIn: 'root'
})
export class MTOItemHdrService extends BaseApiTemplateService<MTOItemHdrContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX +
  Core2Config.FI_PREFIX + Core2Config.MADE_TO_ORDER_PREFIX + 'items';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX +  Core2Config.FI_PREFIX + Core2Config.MADE_TO_ORDER_PREFIX + 'items';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.FI_PREFIX + Core2Config.MADE_TO_ORDER_PREFIX + 'items';
    this.httpClient = http;
  }
}

